<template>
    <div class="legend">
        <div style="display: flex; justify-content: space-between; align-items: center;">
            <h2> {{ contentLegend.title }} </h2>
            <button class="btn" @click="legendDisable">close</button>
        </div>

        <p class="subtitle" v-html="contentLegend.intro"></p>
        <h3> {{ contentLegend.legendTitle }} </h3>
        <h3> {{ contentLegend.swooshTitle }} </h3>
        <p class="subtitle" v-html="contentLegend.swooshText"></p>
        <div class="legendImg">
             <img v-bind:src="'/data/general-media/curricle-one-green-swoosh.png'" alt=""> 
        </div>
        <p class="subtitle" v-html="contentLegend.colorText"></p>
        <div class="legendImg">
             <img v-bind:src="'/data/general-media/curricle-30-year-swoosh.gif'" alt=""> 
        </div>
        <h3> {{ contentLegend.colorTitle }} </h3>
        <div class="types-wrapper">
            <div v-for="type in typesArr" class="type-wrapper">
                <svg class="course-rect" width="60" height="3" fill="red">
                    <defs>
                        <linearGradient :id="type.gradientId" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" :style="`stop-color:rgb(255,255,255);stop-opacity:0`" />
                            <stop offset="100%" :style="`stop-color:${type.color};stop-opacity:1`" />
                        </linearGradient>
                    </defs>
                    <rect x="0" y="0" width="60" height="3" :fill="`url(#${type.gradientId})`"/>
                </svg>
                <span>{{type.label}}</span>
            </div>
        </div>
        <h3> {{ contentLegend.axisTitle }} </h3>
        <p class="subtitle" v-html="contentLegend.axisText"></p>
        <div class="legendImg">
             <img v-bind:src="'/data/general-media/curricle-lens-time-cluster.gif'" alt=""> 
        </div>
        <h3> {{ contentLegend.hoverTitle }} </h3>
        <p class="subtitle" v-html="contentLegend.hoverText"></p>
        <div class="legendImg">
             <img v-bind:src="'/data/general-media/curricle-lens-hover-classes.gif'" alt=""> 
        </div>
        <h3> {{ contentLegend.dataTitle }} </h3>
        <p class="subtitle" v-html="contentLegend.dataText"></p>
        <h3> {{ contentLegend.aboutTitle }} </h3>
        <p class="subtitle" v-html="contentLegend.aboutText"></p>
    </div>
</template>

<script>
    export default {
        name: 'Legend',
        props: ['content'],
        computed: {
            contentLegend() {
                let legendObj = {
                    title: 'About the project',
                    intro: 'Curricle Lens uses data narration to explore the conversational nature of the Harvard curriculum.',
                    legendTitle: 'How to read this visualization',
                    swooshTitle: 'The swoosh',
                    swooshText: 'Each individual colored "swoosh" in the interactive visualization on the left represents one class. Classes only taught once are colored green.',
                    colorText: 'Classes taught multiple times throughout the curriculum, begin in red, and transition over time from purple to blue, the longer that specific class is taught.',
                    colorTitle: 'Color Coding',
                    axisTitle: 'Axis',
                    axisText: 'Semesters are represented horizontally from left to right. Vertically, the classes are sorted into different categorizations, such as  forms that courses take (e.g., seminar, lecture, conference, etc.), or departments within the University.',
                    hoverTitle: 'Hovering interaction',
                    hoverText: 'Hovering visualization displays  class titles, revealing changes over time.',
                    subtitle: 'Here comes a small paragraph on how to read the visualization. Put here as much content as preferred. Here comes a small paragraph on how to read the visualization. Put here as much content as preferred.',
                    dataTitle: 'The dataset',
                    dataText: 'Our data are the contents of online Harvard course catalogues from 1990 to the present, archived by the office of the Registrar. In fact the data go back farther than this, although in the decades prior to 1990 they are spottier, more ragged, digitized fitfully for unknown reasons over the recent years. We complemented the Registrar data by transcribing and digitalizing print information from the archives. These data allow us to track when courses first appear, how often they are offered, and what changes occur in them along the way; we have course titles, descriptions, and schedules, as well as the names of instructors, and the forms that courses take (e.g., seminar, lecture, conference, etc.).',
                    aboutTitle: 'The Project',
                    aboutText: 'A research project of metaLAB (at) Harvard, as part of the Curricle initiative. With support from the office of the Dean of Arts and Humanities and the Menschel Fund, and with the collaboration of the Berkman Klein Center for Internet and Society.',
                }
                // return this.content.legend;
                return legendObj;
            },
            typesArr() {
                return this.content.legend.types;
            },
        },
        methods: {
            legendDisable() {
                document.querySelector('.legend').classList.remove('visible');
                document.querySelector('.btn-toggle-legend').classList.remove('active');
                document.querySelector('.btn-toggle-sidebar').classList.add('active');
                this.$store.dispatch("TOGGLE_LEGEND", false);
            },
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';

    .legend {
        z-index: 3;
        width: 100%;
        bottom: 0;
        width: 290px;
        display: none;
        margin-left: 15px;

        @media screen and (max-width: 320px) {
            width: 265px;
        }

        &.visible {
            display: block;
        }

        .btn {
            border: none;
            border-radius: 4px;
            font-size: $font-size-m;
            background: #eeeeee;
            cursor: pointer;
            padding: 5px 8px;
            transition: all $time-xs ease;
            font-weight: bold;
            margin-top: 15px;
            height: 26px;

            svg {
                transform: translateY(1px);
                g {
                    g {
                        stroke: black;
                    }
                }
            }

            &:hover {
                background: #d4d4d4;
                color: black;
                transition: all $time-xs ease;

                            svg {
                g {
                    g {
                        stroke: black;
                    }
                }
            }
            }

            &:focus {
                outline: none;
            }
        }


        h3.subtitle {
            font-size: 10px;
            letter-spacing: 1.5px;
            font-family: 'IBM Plex Mono';
            text-transform: uppercase;
        }

        h2 {
            font-size: 20px;
            margin: 15px 0 0 0;
        }

        h3 {
            font-size: 13px;
            letter-spacing: .25px;
            margin-bottom: 10px;
            margin-top: 20px;
        }

        p {
            margin-top: 5px;
            font-size: 13px;
            line-height: 160%;
            margin-bottom: 20px;
        }

        .legendImg img{
            border-radius: 8px;
        }

        .types-wrapper {
            display: flex; 
            flex-direction: column;    
            flex-wrap: wrap;       
            padding: 5px 0 8px 8px;
            border-radius: 8px;
            background: #fff;
            margin-bottom: 25px;
            margin-left: 0px;
            margin-right: 100px;

            .type-wrapper {

                width: 200px;

                span {
                    font-size: 13px;
                    font-family: 'IBM Plex Sans';
                    font-size: 10px;
                    // text-transform: uppercase;
                }
            }
        }

        .course-rect {
            padding-bottom: 3px;
            padding-right: 10px;
        }
    }
</style>


